import {message} from 'antd'
import moment from 'moment'

const DATE_FORMATS = [
	'YYYY-MM-DD hh:mm A',
	'YYYY-MM-DD h:mm A',
	'YYYY-MM-DD HH:mm:ss',
	'YYYY-MM-DD HH:mm',
	'YYYY-MM-DD',
	moment.ISO_8601,
]

export const parseDate = value => {
	const parsed = moment(value, DATE_FORMATS, true)
	return parsed.isValid() ? parsed : moment(value)
}

export const handleError = (error, setLoading = () => {}) => {
   let msg = error.message
   let rsp = error.response

   setLoading(false)

   if(!rsp) return message.error('Error Fatal. Favor comunicarse con soporte@smart4.com.co. ' + msg)

   // If is unauthorize redirect to login
   if(rsp.status === 403 && rsp.config.url !== '/#/auth/login')
      message.error('No posee permisos para esta acción.')
   
   if(rsp.status === 401) window.location.href = '/#/auth/logout'

   // Default messages
   if( rsp.status === 404) msg = 'No se encontraron resultados (404).'
   if( rsp.status === 500) msg = 'Oops error en el servidor. Escriba a soporte@smart4.com.co'

   // If api response has error message set it as default
   if( rsp.data.message ) msg = rsp.data.message

   // Force messages
   if( rsp.status === 422) {      
      msg = ''
      for (let [key, value] of Object.entries(rsp.data.errors)) {
         msg += `[${key}]: ${value.join(', ')}. `
      }
   }

   // Show antd error message
   return message.error(`${msg}`, 6)
}

export const parsePagination = response => {
   let meta = response.data.meta

   return { 
      page: meta.current_page, 
      current_page: meta.current_page, 
      per_page: parseInt(meta.per_page), 
      total: meta.total 
   }
}

export const round = num => (
	Math.round((num + Number.EPSILON) * 100) / 100
)

export const numberFormat = num => (
	num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0
)

export const colors = {
   primary: '#1F7CAE',
   accent: '#f37435',
   success: '#8fc74a',
   dark: '#073a56',
   danger: '#d61b1b',
   warning: '#ebd102',
}